import { Dispatch, SetStateAction } from "react";

export type StepProps<T extends StepContext> = {
    context: T;
    setContext: Dispatch<SetStateAction<T>>;
    nextStep: () => void;
    screenId: string;
    onSubmit?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
    onSkip?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
    onLoad?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
};

export type SetupProps<T extends StepContext> = {
    screens: StepScreen<T>[];
    initialContext?: T;
};

export type StepContext = {
    taskId?: string;
    projectId?: string;
    tenantId: string;
    spaceName?: string;
    template?: typeof TemplateOptionScrum | typeof TemplateOptionKanban;
    teamType?: string;
    dueDate?: number;
    promisesToResolve: (Promise<void> | (() => Promise<void>))[];
};

export const TemplateOptionScrum = "SCRUM";
export const TemplateOptionKanban = "KANBAN";

type StepScreen<T extends StepContext> = SplitStepScreen<T> | FullStepScreen<T>;

type SplitStepScreen<T extends StepContext> = {
    type: "split";
    screenId: string;
    header?: string;
    subheader?: string;
    LeftComponent: React.ComponentType<StepProps<T>>;
    RightComponent: React.ComponentType<StepProps<T>>;
    onSubmit?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
    onSkip?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
    onLoad?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
};

type FullStepScreen<T extends StepContext> = {
    type: "full";
    screenId: string;
    header?: string;
    subheader?: string;
    ScreenComponent: React.ComponentType<StepProps<T>>;
    onSubmit?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
    onSkip?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
    onLoad?: ({
        context,
        setContext
    }: {
        context: T;
        setContext: Dispatch<SetStateAction<T>>;
    }) => Promise<void>;
};
